import { BForm } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBForm when migrating. */
export const EgBForm = createEgBootstrapProxy("EgBForm", BForm);
